

class DisclosureToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.panel = this.querySelector('[data-disclosure-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
  }
  toggle() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', String(!expanded));
    this.panel.hidden = expanded;
  }
}
customElements.define('disclosure-toggle', DisclosureToggle);

function formatMoney(value) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'EUR' }).format(value);
  } catch (_) {
    return `€${value.toFixed(2)}`;
  }
}

function initBookingForms() {
  document.querySelectorAll('.product-form--booking').forEach((form) => {
    const unitEl = form.querySelector('[data-unit-price]');
    const participants = form.querySelector('[data-participants]');
    const shipping = form.querySelector('[data-shipping-method]');
    const variantSelect = form.querySelector('[data-variant-select]');
    const summaryUnitEls = form.querySelectorAll('[data-summary-unit]');
    const summaryTotal = form.querySelector('[data-summary-total]');
    const summaryShipping = form.querySelector('[data-summary-shipping]');
    const bookingQuantity = form.querySelector('[data-booking-quantity], [data-quantity-input]');
    const participantsProperty = form.querySelector('[data-participants-property]');
    const gameLanguageProperty = form.querySelector('[data-game-language-property]');
    const skuProperty = form.querySelector('[data-sku-property]');
    const skuLabel = form.querySelector('[data-sku-label]');
    const availability = form.querySelector('[data-availability]');
    const submit = form.querySelector('.product-form__submit');
    if (!participants || !summaryTotal) return;

    const getSelectedVariant = () => {
      if (!variantSelect) return null;
      if (variantSelect.tagName === 'SELECT') return variantSelect.selectedOptions?.[0] || null;
      return variantSelect;
    };

    const update = () => {
      const selectedVariant = getSelectedVariant();
      const unit = Number(selectedVariant?.dataset?.price || unitEl?.dataset?.unitPrice || 0);
      const unitMoney = selectedVariant?.dataset?.priceMoney || formatMoney(unit);
      const sku = selectedVariant?.dataset?.sku || '';
      const available = selectedVariant?.dataset?.available !== 'false';
      const minimum = Number(participants.min || 1);
      const count = Math.max(Number(participants.value || 0), minimum);
      if (Number(participants.value || 0) < minimum) participants.value = String(minimum);
      const gameLanguage = selectedVariant?.dataset?.gameLanguageLabel || selectedVariant?.textContent?.trim() || '';
      const selectedShipping = shipping?.selectedOptions?.[0];
      const shippingValue = Number(selectedShipping?.dataset?.shipping || 0);

      if (bookingQuantity) bookingQuantity.value = String(count);
      if (participantsProperty) participantsProperty.value = String(count);
      if (gameLanguageProperty && gameLanguage) gameLanguageProperty.value = gameLanguage;
      if (unitEl) {
        unitEl.dataset.unitPrice = String(unit);
        unitEl.textContent = unitMoney;
      }
      summaryUnitEls.forEach((el) => { el.textContent = unitMoney; });
      summaryTotal.textContent = formatMoney(unit * count + shippingValue);
      if (summaryShipping) summaryShipping.textContent = shippingValue > 0 ? formatMoney(shippingValue) : (summaryShipping.textContent || 'Calculated at checkout');
      if (skuProperty) skuProperty.value = sku;
      if (skuLabel) skuLabel.textContent = sku;
      if (availability) {
        const baseText = available ? (availability.dataset.availableLabel || availability.textContent.split('·')[0].trim()) : (availability.dataset.unavailableLabel || availability.textContent.split('·')[0].trim());
        availability.textContent = sku ? `${baseText} · ${sku}` : baseText;
      }
      if (submit) submit.disabled = !available;
    };

    ['input', 'change'].forEach((eventName) => {
      participants.addEventListener(eventName, update);
      shipping?.addEventListener(eventName, update);
      variantSelect?.addEventListener(eventName, update);
    });
    update();
  });
}

function initCartMinimums() {
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    const message = form.querySelector('[data-cart-minimum-message]');
    const normalize = () => {
      let corrected = false;
      form.querySelectorAll('[data-cart-quantity][data-min-quantity]').forEach((input) => {
        const min = Number(input.dataset.minQuantity || input.min || 0);
        const value = Number(input.value || 0);
        if (min > 0 && value > 0 && value < min) {
          input.value = String(min);
          corrected = true;
        }
      });
      if (message) message.hidden = !corrected;
      return corrected;
    };
    form.querySelectorAll('[data-cart-quantity][data-min-quantity]').forEach((input) => {
      ['input', 'change'].forEach((eventName) => input.addEventListener(eventName, normalize));
    });
    form.addEventListener('submit', (event) => {
      if (normalize()) {
        event.preventDefault();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBookingForms();
  initCartMinimums();
});
